import { EnumDto } from "../../dto/enum.dto";
import { BlockSubType } from "../../models/building-blocks/building-block-template.model";
import { BuildingBlockSubType } from "../../models/building-blocks/building-block-sub-type.model";
import { enumLabelKey } from "../enum.mapper";

export class BuildingBlockSubTypeMapper {
  /** `title` is the translation key of the sub type's label; render it with the transloco pipe. */
  public static toModel(dto: EnumDto): BuildingBlockSubType {
    return {
      id: dto.id,
      code: dto.description as BlockSubType,
      title: enumLabelKey('buildingBlockSubTypes', dto.description)
    }
  }
}
